import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/_services/user/user.service';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ExitProcessService } from 'src/app/_services/exit-process/exit-prosess.service';

@Component({
  selector: 'app-exit-department',
  templateUrl: './exit-department.component.html',
  styleUrls: ['./exit-department.component.scss']
})
export class ExitDepartmentComponent implements OnInit {
  @Output() clearanceEvent = new EventEmitter<any>();
  tenantId: string;
  userDropdownList = [];
  resignationId: any;
  isHRAdmin: boolean;
  isFinanceAdmin: boolean;
  isITAdmin: boolean;
  isManager: boolean;
  currentUser: any;
  deptClearanceForm;
  form: FormGroup;
  clearanceUserId: any;
  editUserClearanceId: any;
  userClearanceData: any[] = [];
  userClearance= [];
  isManagerCleared: boolean = false;
  clearanceFromManagerItem: any;
  isClearanceForm: boolean = false;
  modeAction: number = 1; //1 - create // 2 - update
  formMode: number = 0; // 0 - none // 1 - new form // 2 - edit form
  defaultColDef:any;
  rowSelection:any
  dataSource: any;
  public columnDefs: ColDef[];
  sampleGridFrameworkComponents: any;
  private api: GridApi;
  private columnApi: ColumnApi;
  selectedRow: any;
  rowData: any;
  isAckVisible: boolean;

  constructor(
    private storageService: LocalStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private exitProcessService: ExitProcessService,
    private userService: UserService
  ) {
      this.route.queryParams.subscribe(params => {
        this.resignationId = params['resignationId'];
      });
      {
        this.defaultColDef = {
          flex: 1,
          minWidth: 100,
          resizable: true,
        };
      }

      this.deptClearanceForm = this.formBuilder.group({
        itemName: new FormControl(''),
        status: new FormControl(''),
        clearanceType: new FormControl(''),
        extraColumn1: new FormControl(''),
      });
   }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.isHRAdmin = this.currentUser.roles.includes('RoleHrmAdministrator');
    this.getUserSeparation(this.resignationId);
  }

  getUserSeparation(resignationId){
    this.exitProcessService.getUserSeparationsById(resignationId).subscribe({
      next : (value) => {
        this.clearanceUserId = value['userId'];
        this.getUserById(this.clearanceUserId);
        this.getUserDeptClearance();

        const clearanceData1 = this.userClearanceData.find(data => data.itemName === 'Clearance from Reporting Manager');
        const isDeptCleared = clearanceData1 ? clearanceData1.status === "Done" : null;

        const clearanceData2 = this.userClearanceData.find(data => data.itemName === 'Clearance From IT');
        const isITCleared = clearanceData2 ? clearanceData2.status === "Yes" : null;

        const clearanceData3 = this.userClearanceData.find(data => data.itemName === 'Clearance From Finance');
        const isFinanceCleared = clearanceData3 ? clearanceData3.status === "Yes" : null;

        const clearanceData4 = this.userClearanceData.find(data => data.itemName === 'Clearance From HR & Admin');
        const isHRCleared = clearanceData4 ? clearanceData4.status === "Yes" : null;
        
        if(isDeptCleared && isITCleared && isFinanceCleared && isHRCleared){
          this.isAckVisible === true
        }
      },
      error(err) {
        this.openSnackBar('ERROR: Getting Resignation Details' + err);
      },
      complete() {
        // this.getUserClearance();
      }
    });
  }

  getUserById(clearanceUserId) {
    this.userService.getUser(clearanceUserId).subscribe({
      next: (response) => {
        if(this.currentUser.id === response['supervisorId']){
          this.isManager = true;
        }
        else{
          this.isManager = false;
        }
      },
      error: () => {

      },
      complete: () => {

      }
    })
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  getUserDeptClearance(){
    this.exitProcessService.getUserClearanceForm('ReportingManager', this.resignationId).subscribe({
      next : (value: any) => {
        this.userClearanceData = [];
        //this.userClearanceData = value;

        this.userClearanceData = value.filter(
          item => item.clearanceType === 'ReportingManager' &&
          item.itemName !== 'Clearance from Reporting Manager' // exclude this from table
        );

        this.clearanceFromManagerItem = value.find(
          item => item.clearanceType === 'ReportingManager' &&
                  item.itemName === 'Clearance from Reporting Manager'
        );

        this.isManagerCleared = value.find(
          item =>
            item.clearanceType === 'ReportingManager' &&
            item.itemName === 'Clearance from Reporting Manager'
        )?.status;


        this.clearanceEvent.emit(value);
      },
      error(err) {
        this.openSnackBar('ERROR: Getting Clearance Details' + err);
      },
      complete() {
        // this.getUserClearance();
      }
    });
  }

  onReportingManagerClearanceChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    const newStatus = checked ? 'Yes' : 'No';
  
    let updatePayload = {
      userId: this.clearanceUserId,
      itemName: this.clearanceFromManagerItem.itemName,
      status: newStatus,
      clearanceType: 'ReportingManager',
    }

    this.exitProcessService.editClearanceInterviewForm(updatePayload, this.clearanceFromManagerItem.id).subscribe({
      next: () => {
        this.clearanceFromManagerItem.status = newStatus;
        this.openSnackBar('Clearance status updated!!!');
      },
      error: (err) => {
        this.openSnackBar('Error updating clearance: ' + err);
      }
    });
  }

  cancelSave(){
    this.formMode = 0;
    this.isClearanceForm = false;
  }

  requiredSaveUserClearance() {
    if (this.deptClearanceForm.status === 'INVALID') return true;
    else return false;
  }

  updateUserDeptClearance(){
    let data = {
      userId: this.clearanceUserId,
      itemName: this.deptClearanceForm.get('itemName').value,
      status: this.deptClearanceForm.get('status').value,
      extraColumn1: this.deptClearanceForm.get('extraColumn1').value,
      clearanceType: 'ReportingManager',
    }
    if (!this.requiredSaveUserClearance()) {
      this.exitProcessService.editClearanceInterviewForm(data, this.editUserClearanceId).subscribe({
        next: (value) =>{
          this.getUserDeptClearance();
        },
        error(error){
          this.openSnackBar('ERROR: ' + error);
        },
        complete(){
          this.openSnackBar('Update Successfull!!!');
        }
      });
    }
  }

  editUserDeptClearanceById(id) {
    this.formMode = 2;
    this.isClearanceForm = true;
    const idx = this.userClearanceData.findIndex(i => i.id === id);
    this.editUserClearanceId = id;
    this.deptClearanceForm.patchValue({
      itemName: this.userClearanceData[idx].itemName,
      status: this.userClearanceData[idx].status,
      extraColumn1: this.userClearanceData[idx].extraColumn1
    });
  }

  visibleUserClearanceForm() {
    if (this.formMode === 0) {
      this.isClearanceForm = true;
      this.formMode = 1;
      this.deptClearanceForm.patchValue({
          itemName: '',
          status: '',
          clearanceType: '',
          extraColumn1: '',
      })
    } else if (this.formMode === 1) {
      this.deptClearanceForm = false;
      this.formMode = 0;
    }
  }

  saveUserDeptClearance(){
    let data = {
      userId: this.clearanceUserId,
      itemName: this.deptClearanceForm.get('itemName').value,
      status: this.deptClearanceForm.get('status').value,
      extraColumn1: this.deptClearanceForm.get('extraColumn1').value,
      clearanceType: 'ReportingManager',
    }
    console.log('data', data);
    if (!this.requiredSaveUserClearance()) {
      this.exitProcessService.createClearanceInterviewForm(data).subscribe({
        next: (value) =>{
          this.getUserDeptClearance();
          this.cancelSave();
          this.formMode = 0;
          this.deptClearanceForm = false;
        },
        error(error){
          this.openSnackBar('ERROR: ' + error);
        },
        complete(){
          this.openSnackBar('Create Successfull!!!');
        }
      });
    }
  }

  backToExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-process']);
  }

  openExitForm(){
    this.router.navigate([this.tenantId + '/dashboard/hr/exit-formalities/exit-form'], { queryParams: { resignationId: this.resignationId } });
  }

  openItHrmExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-hrit' ], { queryParams: { resignationId: this.resignationId } });
  }

  openFinanceExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-finance'], { queryParams: { resignationId: this.resignationId } });
  }

  openHrExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-hr-admin'], {queryParams: {resignationId: this.resignationId}});
  }
 
  employeeAnknow(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/emply-anknowledge'], {queryParams: {resignationId: this.resignationId}});
  }

}
